// eslint-disable-next-line @typescript-eslint/no-unused-vars
declare interface Window {
  iu: {
    ajax: (...args: any) => void,
  };
  categoryMultiselect: any;
}

type SearchResult = {
  cardsHtml: string;
  paging: {
    pagerHtml: string;
    totalHtml: string;
    pagesCount: number;
  }
};

type SearchByDateResult = {
  daysHtml: string;
  dateHtml: string;
  eventsByDate: any
  preselectedEventKey: string;
};

const EventsPage = (() => {
  // Пэйджинг и фильтрация карточек
  const cardsPaging = {
    currentPage: 0,
    pagesCount: 0,
  };

  const showSkeletons = () => {
    const skeletonsSources = $('.js-cards .event-card');
    if (!skeletonsSources.length) {
      return;
    }

    let skeletonsHtml = '';
    $(skeletonsSources).each((index, element) => {
      const itemHeight = $(element).outerHeight() ?? 380;
      skeletonsHtml += `
        <div class="event-card cards__card event-card-skeleton" style="height: ${itemHeight}px">
          <div class="event-card__image skeleton-image">
              &nbsp;
          </div>
          <div class="event-card__content">
              <div class="event-card__type">
                  <div class="skeleton" style="width: 130px; height: 20px; display: inline-block; border-radius: 36px;">&nbsp;</div>
              </div>
              <div class="event-card__title">
                  <div class="skeleton" style="width: 100%">&nbsp;</div>
                  <div class="skeleton" style="width: 80%">&nbsp;</div>
              </div>

              <div class="event-card__footer">
                  <div class="event-card__certificate event-certificate event-certificate--golden">
                      <div class="event-certificate__image-container">
                          <div class="skeleton" style="width: 67px; height: 56px">&nbsp;</div>
                      </div>
                      <span class="event-certificate__text event-card__certificate-text">
                          <div class="skeleton" style="width: 50%; height: 18px; margin-bottom: 2px;">&nbsp;</div>
                          <div class="skeleton" style="width: 30%; height: 18px;">&nbsp;</div>
                      </span>
                  </div>
                  <div class="event-card__footer-items">
                      <div class="skeleton" style="width: 70%">&nbsp;</div>
                  </div>
              </div>
          </div>
      </div>`;
    });
    $('.js-cards').html(skeletonsHtml);
  };

  const restoreScroll = () => {
    const $content = $('#events_sections');
    const headerHeight = document.getElementById('header-menu').clientHeight;
    let offset = $content.offset().top - headerHeight - 20;
    if (window.innerWidth <= 1230) {
      offset = $content.offset().top - 10;
    }
    $('html, body').stop().animate({
      scrollTop: offset,
    }, 150);
  };

  const setUrl = (formSelector, nextPage = null) => {
    // Get the form
    const form = document.querySelector(formSelector);

    // Get all field data from the form
    const data = new FormData(form);
    if (nextPage) {
      data.set('page', nextPage);
    }
    const url = `/meropriyatiya?${new URLSearchParams(data).toString()}`;
    window.history.pushState({ url }, document.title, url);
  };

  const loadPage = (nextPage) => {
    const filterData = $('.js-filter-form').serializeArray();
    filterData.push({ name: 'page', value: nextPage });
    setUrl('.js-filter-form', nextPage);
    restoreScroll();
    showSkeletons();
    window.iu.ajax(null, '/events/api/list', filterData, (data: SearchResult) => {
      cardsPaging.currentPage = nextPage;
      cardsPaging.pagesCount = data.paging.pagesCount;
      $('.js-cards').html(data.cardsHtml);
      $('.js-paging').html(data.paging.pagerHtml);
      $('.js-cards-count').html(data.paging.totalHtml);
    });
  };
  const search = (form) => {
    const formData = $(form).serializeArray();
    setUrl(form);
    showSkeletons();
    window.iu.ajax(null, '/events/api/list', formData, (data: SearchResult) => {
      $('.js-cards').html(data.cardsHtml);
      $('.js-cards-count').html(data.paging.totalHtml);
      $('.js-paging').html(data.paging.pagerHtml);
      cardsPaging.currentPage = 1;
      cardsPaging.pagesCount = data.paging.pagesCount;
    });
  };

  // Пэйджинг, состояние и логика календаря
  const calendar = {
    selectedYear: 0,
    selectedMonth: 0,
    selectedEventKey: '',
    monthEvents: {},
  };

  const selectEvent = (eventKey: string) => {
    const eventData = eventKey.split(';');
    const $calendarEvents = $('.js-calendar-day-event');
    $calendarEvents.removeClass('calendar__day-event--selected');

    const $selectedEvent = $(`.js-calendar-day-event[data-event-key="${eventKey}"]`);
    $selectedEvent.addClass('calendar__day-event--selected');

    // Выбран элемент из другой даты, нужно перерисовывать весь список событий
    const renderEvents = calendar.monthEvents[eventData[1]];
    if (renderEvents) {
      // Отрисовка шаблона в js
      const eventsRenderHtmlString = renderEvents.reduce((eventsHtmlString, event) => {
        const renderEventDate = event.date_formatted;
        const renderEventKey = `${event.id};${renderEventDate}`;
        let eventClass = 'calendar-event--';
        switch (event.event_type) {
          case 'conference':
            eventClass += 'conference';
            break;
          case 'master_class':
            eventClass += 'master-class';
            break;
          case 'training':
            eventClass += 'training';
            break;
          case 'seminar':
            eventClass += 'seminar';
            break;
          case 'custom':
            eventClass += 'custom';
            break;
          default:
            break;
        }

        if (eventKey === renderEventKey) {
          eventClass += ' calendar-event--selected';
        }

        /* eslint-disable */
        eventsHtmlString += `
          <div class="events-calendar__event calendar-event ${eventClass} js-calendar-event" data-event-key="${renderEventKey}">
                <div class="calendar-event__padding">&nbsp;</div>
                <a class="calendar-event__container" href="${event.url}" target="_blank">
                    <span class="calendar-event__badge badge badge--online">
                        ${event.event_type_text}
                    </span>
                    ${
          event.subtitle ?
            `<div class="calendar-event__event-name">
                            ${event.subtitle}
                        </div>` : ''
        }
                    <div class="calendar-event__event-title">
                        ${event.title}
                    </div>
                    ${
          event.participants ?
            `<div class="calendar-event__participants">
                            ${event.participants.reduce((participantsHtmlString, participant) => {
              participantsHtmlString += `
                                <div class="calendar-event__participant">
                                    <img
                                        width="40"
                                        height="40"
                                        class="calendar-event__participant-avatar"
                                        src="${participant.avatar}"
                                        alt="${participant.name}"
                                    />
                                    <span class="calendar-event__participant-name">
                                        ${participant.name}
                                    </span>
                                </div>
                                `;
              return participantsHtmlString;
            }, '')}
                        </div>` : ''
        }
                    <div class="calendar-event__footer">
                        <div class="calendar-event__certificate event-certificate">
                          <div class="event-certificate__image-container">
                              <img
                                  width="62"
                                  height="52"
                                  class="event-certificate__image"
                                  src="${event.certificate_image_url}"
                                  alt="${event.certificate_text ?? 'Сертификат участника'}"
                              />
                          </div>
                          <span class="event-certificate__text calendar-event__certificate-text ">
                              ${event.certificate_text ?? 'Сертификат участника'}
                          </span>
                      </div>
                        ${
          event.date && !event.participants ?
            `
                                <div class="calendar-event__info">
                                    <svg class="calendar-event__info-icon" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 2.25h-.75V1.5c0-.4125-.3375-.75-.75-.75s-.75.3375-.75.75v.75h-7.5V1.5c0-.4125-.3375-.75-.75-.75s-.75.3375-.75.75v.75H3c-.825 0-1.5.675-1.5 1.5v12c0 .825.675 1.5 1.5 1.5h12c.825 0 1.5-.675 1.5-1.5v-12c0-.825-.675-1.5-1.5-1.5Zm-.75 13.5H3.75c-.4125 0-.75-.3375-.75-.75V6h12v9c0 .4125-.3375.75-.75.75Z" fill="#267F8C"/></svg>
                                    <span class="calendar-event__info-text">${event.date_formatted}</span>
                                </div>
                                ` : ''
        }
                        <div class="calendar-event__action">
                            <span class="button button--sm button--100">
                                Подробнее
                            </span>
                        </div>
                    </div>
                </a>
            </div>`;
        /* eslint-enable */
        return eventsHtmlString;
      }, '');

      $('.js-calendar-event').remove();
      $('.js-calendar-wrapper').append(eventsRenderHtmlString);

      // Таймаут нужен чтобы точно убедиться, что все элементы отрисованы
      setTimeout(() => {
        // Выставляем классы у блоков справа от календаря
        $('.js-calendar-event').removeClass('calendar-event--selected');
        $(`.js-calendar-event[data-event-key="${eventKey}"]`).addClass('calendar-event--selected');

        // Выставляем классы у элементов дня в календаре
        $('.js-calendar-day').removeClass('calendar__day--with-selected-event');
        $selectedEvent.parents('.js-calendar-day').addClass('calendar__day--with-selected-event');
      }, 0);
    } else {
      $('.js-calendar-event').removeClass('calendar-event--selected');
      $('.js-calendar-day').removeClass('calendar__day--with-selected-event');
      $('.js-calendar-event').html('');
    }

    EventsPage.calendar.selectedEventKey = eventKey;
  };

  const loadDate = (year: number, month: number, event) => {
    window.iu.ajax(event, '/events/api/byDate', { year, month }, (data: SearchByDateResult) => {
      Object.assign(calendar, {
        selectedYear: year,
        selectedMonth: month,
        monthEvents: data.eventsByDate,
        selectedEventKey: data.preselectedEventKey,
      });
      $('.js-current-date').html(data.dateHtml);
      $('#calendar_days').html(data.daysHtml);
      selectEvent(calendar.selectedEventKey || '');

      const currentDate = new Date();
      const selectedDate = new Date(calendar.selectedYear, calendar.selectedMonth - 1);
      const nextPreviousDate = new Date(selectedDate);
      nextPreviousDate.setMonth(selectedDate.getMonth() - 1);
      if (nextPreviousDate < new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)) {
        $('.js-prev-month').prop('disabled', true);
      } else {
        $('.js-prev-month').prop('disabled', false);
      }
    });
  };

  const clearFilters = (form) => {
    $('.filter-form__input', form)
      .val('');

    $('.checkbox__input', form)
      .prop('checked', false);

    window.categoryMultiselect.uncheckOptions($('.multiselect__checkbox-input').toArray());
    window.categoryMultiselect.updateDetails();
    search(form);
  };

  return {
    loadPage,
    loadDate,
    search,
    selectEvent,
    cardsPaging,
    calendar,
    showSkeletons,
    clearFilters,
  };
})();

($.fn as any).isInViewport = function () {
  const elementTop = $(this).offset().top;
  const elementBottom = elementTop + $(this).outerHeight();
  const viewportTop = $(window).scrollTop();
  const viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment -- расширять window для одной страницы не нужно
// @ts-ignore
window.EventsPage = EventsPage;
